import DataDescriptorDTO from "features/shared/dtos/DataDescriptorDTO";

  export const getDataDescriptors = (formValues: Record<string, any>): DataDescriptorDTO[] => {
    let result: DataDescriptorDTO[] = [];

    for (const [key, value] of Object.entries(formValues)) {
        const descriptor: DataDescriptorDTO = {
          code: key,
          value: value === null ? null : String(value)
        }
        result.push(descriptor);
    }

    return result;
  };